import * as React from 'react';

export interface VAFiduciaryIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * VAFiduciaryIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description VA Fiduciary (veterans benefits). VA-labeled document with white star corner badge.
 */
const VAFiduciaryIcon: React.FunctionComponent<VAFiduciaryIconProps> = ({
  className,
  size = 40,
  title = 'VA Fiduciary',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#143f5d" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#143f5d"/>
      <text x="25" y="22" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="10" fontWeight="900" fill="#143f5d" letterSpacing="0.5">VA</text>
      <text x="25" y="27" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="2.5" fontWeight="700" fill="#143f5d" letterSpacing="0.3">FIDUCIARY</text>
      <line x1="14" y1="31" x2="36" y2="31" stroke="#143f5d" strokeWidth="0.8"/>
      <line x1="14" y1="34" x2="32" y2="34" stroke="#143f5d" strokeWidth="0.8"/>
      <circle cx="34" cy="38" r="4.5" fill="#143f5d"/>
      <path d="M34 34 L35 36.5 L37.7 36.7 L35.5 38.3 L36.2 41 L34 39.4 L31.8 41 L32.5 38.3 L30.3 36.7 L33 36.5 Z" fill="#FFFFFF"/>
  </svg>
);

export default VAFiduciaryIcon;
